var map = {
	"./1.png": "707c",
	"./2.png": "16bf",
	"./3.png": "00d0",
	"./4.png": "31fb",
	"./5.png": "f335",
	"./6.png": "8c25",
	"./7.png": "2191",
	"./8.png": "073d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "58ff";